<h2 mat-dialog-title>{{ data.title ?? 'Add hours' }}</h2>
<mat-dialog-content>
  <div class="entity-form">
    <div class="cell-actions">
      <strong style="flex: 1">Credited</strong>
      <mat-form-field>
        <mat-label>Month</mat-label>
        <mat-select [formField]="form.Month">
          @for (month of months(); track month) {
            <mat-option [value]="month">{{ month }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Year</mat-label>
        <mat-select [formField]="form.Year">
          @for (year of yearRange(); track year) {
            <mat-option [value]="year">{{ year }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <mat-form-field>
      <mat-label> Hours </mat-label>
      <input matInput [formField]="form.Hours" type="number" />
    </mat-form-field>

    @if (isCharged()) {
      <div class="cell-actions">
        <strong style="flex: 1"> Expires </strong>
        <mat-form-field>
          <mat-label>Month</mat-label>
          <mat-select [formField]="form.ExpireMonth">
            @for (month of months(); track month) {
              <mat-option [value]="month">{{ month }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Year</mat-label>
          <mat-select [formField]="form.ExpireYear">
            @for (year of yearRange(); track year) {
              <mat-option [value]="year">{{ year }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label> Status </mat-label>
        <mat-select [formField]="form.Status">
          @for (item of statuses(); track item[0]) {
            <mat-option [value]="item[0]">{{ item[1] }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Due Date</mat-label>
        <input matInput [matDatepicker]="picker" [formField]="form.DueDate" />
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <mat-checkbox [formField]="form.Commissionable"> Commissionable </mat-checkbox>

      <mat-form-field>
        <mat-label> Hourly Rate </mat-label>
        <input matInput [formField]="form.HourlyRate" type="number" stept="0.01" />
      </mat-form-field>
    }
    @if (!isUnforeseen()) {
      <mat-form-field>
        <mat-label> Value (in AUD) </mat-label>
        <input matInput type="number" [formField]="form.Value" />
      </mat-form-field>
    }
    @if (isCharged()) {
      <mat-form-field>
        <mat-label> Currency </mat-label>
        <mat-select [formField]="form.Currency">
          <mat-option value="AUD">AUD</mat-option>
          <mat-option value="USD">USD</mat-option>
          <mat-option value="EURO">EURO</mat-option>
          <mat-option value="NZD">NZD</mat-option>
          <mat-option value="CAD">CAD</mat-option>
        </mat-select>
      </mat-form-field>
    }
    @if (form.Currency().value() !== 'AUD') {
      <mat-form-field>
        <mat-label> Exchange Rate </mat-label>
        <input matInput type="number" [formField]="form.Rate" />
        <mat-hint> (1 AUD equals ... {{ form.Currency().value() }}) </mat-hint>
      </mat-form-field>
    }
    <mat-form-field>
      <mat-label> Notes </mat-label>
      <textarea matInput [formField]="form.Notes"></textarea>
    </mat-form-field>

    @if (isCharged()) {
      <mat-form-field>
        <mat-label> Project </mat-label>
        <mat-select [formField]="form.ProjectId">
          @for (item of projects(); track item.Id) {
            <mat-option [value]="item.Id">{{ item.Title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label> Purchase Order </mat-label>
        <input matInput type="number" [formField]="form.PurchaseOrder" />
      </mat-form-field>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button matMiniFab matTooltip="Save resource" (click)="save()" [disabled]="!form().valid() || pending()">
    <mat-icon>save</mat-icon>
  </button>
</mat-dialog-actions>
@if (pending()) {
  <mat-progress-bar mode="indeterminate" />
}
